// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ToggleProjectFeatureMutationVariables = Types.Exact<{
  input: Types.ToggleProjectFeatureInput;
}>;


export type ToggleProjectFeatureMutation = { __typename?: 'Mutation', toggleProjectFeature: { __typename?: 'SaveProjectResult', project:
      | { __typename?: 'StandaloneProject', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Region', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Market', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Community', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Subdivision', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Lot', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Structure', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Unit', id: string, features: Array<Types.ProjectFeature> }
     } };


export const ToggleProjectFeatureDocument = gql`
    mutation ToggleProjectFeature($input: ToggleProjectFeatureInput!) {
  toggleProjectFeature(input: $input) {
    project {
      id
      features
    }
  }
}
    `;

/**
 * __useToggleProjectFeatureMutation__
 *
 * To run a mutation, you first call `useToggleProjectFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProjectFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProjectFeatureMutation, { data, loading, error }] = useToggleProjectFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleProjectFeatureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleProjectFeatureMutation, ToggleProjectFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleProjectFeatureMutation, ToggleProjectFeatureMutationVariables>(ToggleProjectFeatureDocument, options);
      }
export type ToggleProjectFeatureMutationHookResult = ReturnType<typeof useToggleProjectFeatureMutation>;
export type ToggleProjectFeatureMutationResult = ApolloReactCommon.MutationResult<ToggleProjectFeatureMutation>;